<template>
	<div>
		<v-container>
			<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>

			<!-- <v-expansion-panels class="pt-2 pb-5">
				<v-expansion-panel>
					<v-expansion-panel-header disable-icon-rotate>
						<template v-slot:default="{ open }">
							<v-row no-gutters class="text-center">
								<v-col cols="12" class="text--secondary">
									<v-fade-transition leave-absolute>
										<span v-if="open" key="0">
											التصفية
											<v-icon color="primary" left>mdi-filter</v-icon>
										</span>
										<span v-else key="1">
											التصفية
											<v-icon color="primary" left>mdi-filter</v-icon>
										</span>
									</v-fade-transition>
								</v-col>
							</v-row>
						</template>
						<template v-slot:actions>
							<v-icon color="primary"></v-icon>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-row justify="center" dense>
							<v-col cols="12" md="4">
								<v-select
									v-model="filters.state"
									hide-details
									outlined
									label="الحالة"
									:items="states"
									item-text="text"
									item-value="value"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-text-field v-model="filters.user" hide-details outlined label="المستخدم"></v-text-field>
							</v-col>
							<v-col cols="12" md="4">
								<v-menu
									v-model="menu1"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											v-model="dateRangeText"
											outlined
											hide-details="auto"
											label="التاريخ"
											readonly
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker v-model="filters.dates" range no-title></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12">
								<v-radio-group v-model="filters.sort">
									<v-radio label="اخباري" :value="0"></v-radio>
									<v-radio label="اخبار مجموعتي" :value="1"></v-radio>
									<v-radio label="الكل" :value="2"></v-radio>
								</v-radio-group>
							</v-col>
							<v-col cols="12" class="text-center">
								<v-btn color="success" @click="applyFilter">تصفية</v-btn>
							</v-col>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>-->

			<v-data-table
				id="content"
				class="elevation-1"
				:headers="headers"
				:items="records"
				hide-default-footer
				:expanded.sync="expanded"
				:loading="loading"
			>
				<template #top>
					<v-toolbar flat>
						<v-toolbar-title class="px-4">جدول المواضيع المثبتة</v-toolbar-title>
						<v-divider insert vertical></v-divider>
						<v-spacer></v-spacer>
						<v-btn class="primary" to="/dashboard/pinned/add">تثبيت موضوع جديد</v-btn>
					</v-toolbar>
				</template>

				<template #[`item.title`]="{ item }">
					{{ item.title }}
				</template>

				<template #[`item.order`]="{ item }">
					<v-select
						v-if="!item.active"
						v-model="item.order"
						:items="orders"
						outlined
						hide-details="auto"
						label="ترتيب التثبيت"
					></v-select>
					<div v-else>{{ item.order }}</div>
				</template>

				<template #[`item.actions`]="{ item }">
					<v-tooltip bottom>
						<template #activator="{ on }">
							<v-btn icon color="primary" v-on="on" @click="openRecord(item.url)">
								<v-icon>mdi-open-in-new</v-icon>
							</v-btn>
						</template>

						<span>عرض</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.save" bottom>
						<template #activator="{ on }">
							<v-btn :disabled="actionLoading" icon color="primary" v-on="on" @click="save(item.id)">
								<v-icon>mdi-content-save</v-icon>
							</v-btn>
						</template>

						<span>حفظ</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.activate && !item.active" bottom>
						<template #activator="{ on }">
							<v-btn
								:disabled="actionLoading || !(item.order >= 1 && item.order <= 6)"
								icon
								color="primary"
								v-on="on"
								@click="publish(item.id, item.order)"
							>
								<v-icon>mdi-pin</v-icon>
							</v-btn>
						</template>

						<span>تثبيت</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.deactivate && item.active" bottom>
						<template #activator="{ on }">
							<v-btn :disabled="actionLoading" icon color="primary" v-on="on" @click="deactivate(item.id)">
								<v-icon>mdi-pin-off</v-icon>
							</v-btn>
						</template>

						<span>إلغاء التثبيت</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.edit" bottom>
						<template #activator="{ on }">
							<v-btn
								:disabled="actionLoading || item.isEdit"
								icon
								color="primary"
								v-on="on"
								@click="showEditRecord(item)"
							>
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</template>

						<span>تحرير</span>
					</v-tooltip>

					<v-tooltip v-if="item.privileges.delete" bottom>
						<template #activator="{ on }">
							<v-btn
								:disabled="actionLoading"
								icon
								color="primary"
								v-on="on"
								@click="confirmDeleteRecord(item.id)"
							>
								<v-icon>mdi-delete</v-icon>
							</v-btn>
						</template>

						<span>حذف</span>
					</v-tooltip>
				</template>

				<template #expanded-item="{ item }">
					<td :colspan="headers.length">
						<v-col cols="12" sm="10" md="8" class="mx-auto">
							<v-row dense>
								<v-col cols="12" md="6">
									<v-text-field v-model="item.title" outlined hide-details="auto" label="العنوان"></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-select
										v-model="item.order"
										:items="orders"
										outlined
										hide-details="auto"
										label="الترتيب"
									></v-select>
								</v-col>
								<v-col cols="12">
									<v-textarea v-model="item.description" outlined hide-details="auto" label="الوصف"></v-textarea>
								</v-col>
								<v-col cols="12" class="text-center">
									<v-btn class="mx-1" color="error" @click="hideEditRecord(item)">إلغاء</v-btn>
									<v-btn class="mx-1" color="primary" @click="editRecord(item)">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</td>
				</template>
			</v-data-table>

			<v-pagination v-model="page" :length="pageCount" class="pt-3"></v-pagination>

			<app-confirmation-dialog ref="confirm"></app-confirmation-dialog>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";

export default {
	components:{
		AppConfirmationDialog: () => import(/* webpackChunkName: "app-confirmation-dialog" */ "@/components/AppConfirmationDialog"),
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					to: { name: "dashboard-home" }
				},
				{
					text: "المواضيع المثبتة",
					exact: true,
					to: { name: "dashboard-pinned" }
				},
				{
					text: "التحكم",
					disabled: true
				}
			],
			headers: [
				{
					text: "العنوان",
					value: "title"
				},
				{
					text: "الوصف",
					value: "description"
				},
				{
					text: "الترتيب",
					value: "order",
					sortable: false
				},
				{
					text: "العمليات",
					value: "actions"
				}
			],
			records: [],
			pageCount: 1,
			page: 1,
			menu1: false,
			filters: {
				state: null,
				user: null,
				dates: [],
				sort: 0
			},
			storedFilters: {},
			states: [
				{ text: "غير مكتملة", value: "notCompleted" },
				{ text: "مسودة", value: "draft" },
				{ text: "محفوظة", value: "submited" },
				{ text: "منشورة", value: "published" }
			],
			expanded: [],
			loading: true,
			orders: [1, 2, 3, 4, 5, 6],
			actionLoading: false
		};
	},
	computed: {
		dateRangeText() {
			return this.filters.dates.join(" ~ ");
		}
	},
	watch: {
		page(newVal) {
			this.getRecords(newVal);
			this.$vuetify.goTo('#content');
		}
	},
	mounted() {
		this.getRecords(1);
	},
	methods: {
		refresh() {
			this.expanded = [];
			this.actionLoading = false;
			this.loading = true;
			this.records = [];
			this.getRecords(this.page);
		},
		getRecords() {
			client
				.get("/api/pinTopic/allcp", {
					params: this.storedFilters
				})
				.then(response => {
					this.records = response.data.map(record => {
						if (record.order == -1) {
							record.order = 1;
						}
						record.isEdit = false;
						return record;
					});
					this.loading = false;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		applyFilter() {
			this.storedFilters = { ...this.filters };
			this.records = [];
			this.page = 1;
			this.getRecords(1);
		},
		save(recordID) {
			this.actionLoading = true;
			client
				.post("/api/pinTopic/submit/" + recordID)
				.then(response => {
					this.refresh();
					this.$store.dispatch("notify", {
						message: "تم حفظ الخبر"
					});
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		publish(recordID, order) {
			this.actionLoading = true;
			client
				.post("/api/pinTopic/activate/" + recordID + "/" + order)
				.then(response => {
					this.refresh();
					this.$store.dispatch("notify", {
						message: "تم تثبيت"
					});
					console.log(response);
				})
				.catch(err => {
					this.actionLoading = false;
					this.$store.dispatch("notify", {
						message: "فشلت عملية التثبيت",
						color: "error"
					});
					console.log(err);
				});
		},
		deactivate(recordID) {
			this.actionLoading = true;
			client
				.post("/api/pinTopic/deactivate/" + recordID)
				.then(response => {
					this.refresh();
					this.$store.dispatch("notify", {
						message: "تم إلغاء تثبيت"
					});
					console.log(response);
				})
				.catch(err => {
					this.actionLoading = false;
					this.$store.dispatch("notify", {
						message: "فشلت عملية إالغاء التثبيت",
						color: "error"
					});
					console.log(err);
				});
		},
		async confirmDeleteRecord(recordID) {
			const confirmed = await this.$refs.confirm.open({ title: "تأكيد الحذف",  message: "هل تريد حقاً حذف هذا المنشور" });
			if (confirmed) { this.deleteRecord(recordID); }
		},
		deleteRecord(recordID) {
			this.actionLoading = true;
			client
				.delete("/api/pinTopic/delete/" + recordID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					this.refresh();
					this.$store.dispatch("notify", {
						message: "تم حذف الموضوع"
					});
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		openRecord(url) {
			var win = window.open(url, "_blank");
			win.focus();
		},
		showEditRecord(record) {
			record.isEdit = true;
			this.expanded.push(record);
		},
		hideEditRecord(record) {
			var index = this.expanded.indexOf(record);
			this.expanded.splice(index, 1);
			record.isEdit = false;
		},
		editRecord(record) {
			this.expanded = [];
			this.actionLoading = true;
			record.pinTopicID = record.id;
			client
				.post("/api/pinTopic/update", record)
				.then(response => {
					this.refresh();
					this.$store.dispatch("notify", {
						message: "تم حفظ الخبر"
					});
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		}
	}
};
</script>